/**
 * Builds the URL context headers that every FE → BE request should carry, so the
 * back-end can register on which page a request originated.
 *
 * @see https://atlassian.dpgmedia.net/jira/browse/TAPP-2928
 */
export function getClientContextHeaders(url: URL): Record<string, string> {
  return {
    'X-Client-Hostname': url.hostname,
    // URL normalizes an absent http(s) path to '/', and percent-encodes both pathname
    // and search, which keeps these values safe to use as header values.
    'X-Client-Path': url.pathname,
    'X-Client-Query': url.search.replace(/^\?/, ''),
  };
}
